import {MeasurementUnit} from 'constants/__generated/MeasurementUnit';
import {isVolumeUnit} from 'inventory/InventoryUnitUtil';
import {getUnitFromTypedValue} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryUnits';
import {
  StoichiometryStructuredTableMetadata,
  StoichiometryStructuredTableRowMetadata,
} from 'notebook/integrations/chemistry/StoichiometryStructuredTableAdapter';
import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {CustomEval, TypedValue} from 'notebook/tables/TableConstants';
import {EMPTY_TYPED_VALUE} from 'notebook/tables/typed-values/DataTypes';
import {ResolveQueryFn} from 'notebook/tables/typed-values/TypedValueResolution';

export type StoichiometryConcentrationCellDependencies = [amountUnit: TypedValue | null];
interface StoichiometryConcentrationValues {
  amountUnit: MeasurementUnit | null;
}

function transformCellDependenciesToValues(
  cellDependencies: StoichiometryConcentrationCellDependencies
): StoichiometryConcentrationValues {
  const [amountUnitTypedValue] = cellDependencies;
  const amountUnit = amountUnitTypedValue && getUnitFromTypedValue(amountUnitTypedValue);
  return {
    amountUnit,
  };
}

const stoichiometryConcentrationCustomEval: CustomEval<{
  tableMetadata: StoichiometryStructuredTableMetadata;
  rowMetadata: StoichiometryStructuredTableRowMetadata;
}> = (
  typedValue: TypedValue,
  columnDefinition: ColumnDefinition,
  cellDependencies: Array<TypedValue | null>,
  customEvalOptions: unknown,
  resolveFromResolutionQuery: ResolveQueryFn
) => {
  const {amountUnit} = transformCellDependenciesToValues(
    cellDependencies as StoichiometryConcentrationCellDependencies
  );
  // If we don't have an amount unit (because it's not specified or not loaded), optimistically show the
  // concentration cells.
  if (!amountUnit || isVolumeUnit(amountUnit)) {
    return {val: typedValue, error: null, locked: false};
  }
  // Otherwise, hide the values and lock the cell.
  return {val: EMPTY_TYPED_VALUE, error: null, locked: true};
};

export default stoichiometryConcentrationCustomEval;
